import React, { useCallback } from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

import type { Iconography, SectionIds } from '../../types';

const styles = cssMap({
	heading: {
		flexGrow: 1,
	},
	label: {
		display: 'block',
		flexGrow: 1,
	},
	section: {
		paddingBlock: token('space.150'),
	},
});

type VisualRefreshProps = {
	iconography: Iconography;
	onIconographyChange?(iconography: Iconography): void;
	testId?: string;
	hiddenSections?: SectionIds;
};

/**
 * __Visual refresh__
 *
 * The visual refresh section of the appearance controls form.
 */
const VisualRefresh = ({
	iconography,
	onIconographyChange,
	testId,
	hiddenSections,
}: VisualRefreshProps) => {
	const toggleIconography = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			if (e.target.checked) {
				onIconographyChange?.('new');
			} else {
				onIconographyChange?.('legacy');
			}
		},
		[onIconographyChange],
	);

	return (
		<>
			<Stack space="space.050">
				<Inline space="space.100" shouldWrap>
					<Box xcss={styles.heading}>
						<Heading size="xsmall" as="h2" id="styles">
							Design language
						</Heading>
					</Box>
					<Link href="/whats-new/atlassian-ui-refresh-updates" target="_blank">
						About our new design language
					</Link>
				</Inline>
			</Stack>
			{!hiddenSections?.includes('iconography') && (
				<Inline space="space.025" alignBlock="center" xcss={styles.section}>
					<Box xcss={styles.label}>
						<Text size="small" id="iconography">
							Iconography
						</Text>
					</Box>
					<Toggle
						isChecked={iconography === 'new'}
						onChange={toggleIconography}
						testId={testId ? `${testId}--iconography` : undefined}
						label="Iconography"
					/>
				</Inline>
			)}
		</>
	);
};

export default VisualRefresh;
